// extracted by mini-css-extract-plugin
export default {"pageSubHeader":"ChangeVignetPageCalculations_pageSubHeader__EX8Zj"};